import React from 'react';
import DefaultResultItem from './DefaultResultItem';
import { ResultItemProps } from 'components/ui/Results/ResultItem';
// #region Commerce
import ProductResultItem from './commerce/ProductResultItem';
// #endregion

function RocHawkResultItemHCL({ item, testId, productPricingAndAvailability, isLoadingPricing }: ResultItemProps) {
	const itemType = item.getDocumentValue('roctype');

	switch (itemType) {
		// #region Commerce
		case 'Product':
			return (
				<ProductResultItem
					item={item}
					testId={testId}
					productPricingAndAvailability={productPricingAndAvailability}
					isLoadingPricing={isLoadingPricing}
				/>
			);
		// #endregion
		default:
			return <DefaultResultItem item={item} testId={testId} isLoadingPricing={isLoadingPricing} />;
	}
}

export default RocHawkResultItemHCL;
